<template>
  <div class="salary-rules__rule-container">
    <!-- Toggler -->
    <div class="d-input-group--toggler"
         :class="{'d-input-group--toggler--active': isOn}"
         @click="setIsOn">
      <label class="d-label">
        Skal vikaren have ekstra løn før første lektion?
      </label>
      <AppToggle :allowChanges="false" :propOn="isOn"></AppToggle>
    </div>

    <!-- Dynamiske inputfelter -->
    <div class="d-groups" v-if="isOn">
      <div class="d-groups__group"
           v-for="(timeItem, index) in atStartOfDay"
           :key="index">
        <span class="icon__bg-circle icon__bg-circle--danger d-groups__group__delete-item"
              @click="deleteItem(index)"
              :content="'Slet dette starttidspunkt'"
              v-tippy="{
                    arrow: false,
                    placement : 'right'
                  }">
          <span class="icon-bin"></span></span>
        <div class="d-group">
          <label class="d-label">Angiv tidspunkt for første lektion</label>
          <input type="time" class="d-input"
                 :value="timeItem.time"
                 @input="updateTime($event, index)">
        </div>
        <div class="d-group">
          <label class="d-label">Hvor mange minutter skal vikaren have ekstra?</label>
          <input
            type="number"
            class="d-input"
            :value="timeItem.minutes"
            @input="updateMinutes($event, index)"
          >
        </div>
      </div>
      <button class="btn-trans" @click="addTime">+ Tilføj starttidspunkt</button>
    </div>

    <!-- Regel-komponent -->
    <SalaryRulesRule
      v-if="isOn"
      :subjectType="subjectType"
      :propSelectedEmploymentTypeId="selectedEmploymentTitle"
      @change="setRuleEmployment"
    >
    </SalaryRulesRule>

    <!-- Gem-knap -->
    <div class="d-modal__buttons" v-if="isChangesMade">
      <button class="do-bttn do-bttn--submit" @click="onSubmit">{{ $t('vue2.common.save') }}</button>
    </div>
  </div>
</template>

<script>
import AppToggle from '../../common/AppToggle.vue'
import SalaryRulesRule from './SalaryRulesRule.vue'

export default {
  components: {SalaryRulesRule, AppToggle},
  props: {
    config: {
      type: Object,
      default: null
    },
    propRules: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      isOn: false,
      atStartOfDay: [],
      subjectType: '_extra_time_at_start_of_day_',
      selectedEmploymentTitle: '',
      isChangesMade: false
    }
  },
  methods: {
    updateTime (event, index) {
      this.atStartOfDay[index].time = event.target.value
      this.isChangesMade = true
    },
    updateMinutes (event, index) {
      this.atStartOfDay[index].minutes = parseInt(event.target.value, 10) || 0
      this.isChangesMade = true
    },
    setRuleEmployment (selectedEmploymentTitle) {
      this.selectedEmploymentTitle = selectedEmploymentTitle
      this.isChangesMade = true
    },
    newRulesArr () {
      if (!this.isOn || this.selectedEmploymentTitle === '') {
        return this.propRules.filter(item => item.id !== this.subjectType)
      }
      const dbRules = JSON.parse(JSON.stringify(this.propRules))
      const idx = dbRules.findIndex(item => item.id === this.subjectType)
      if (idx < 0) {
        const newRuleObj = {
          id: this.subjectType,
          type: 'subject_type',
          subject_type: this.subjectType,
          selected_employment_title: this.selectedEmploymentTitle
        }
        dbRules.unshift(newRuleObj)
      } else {
        dbRules[idx].selected_employment_title = this.selectedEmploymentTitle
      }
      return dbRules
    },
    setIsOn () {
      this.isOn = !this.isOn
      this.isChangesMade = true
      if (this.atStartOfDay.length === 0) {
        this.atStartOfDay.push({time: '08:00', minutes: 10})
      }
    },
    addTime () {
      this.atStartOfDay.push({time: '08:00', minutes: 10})
      this.isChangesMade = true
    },
    deleteItem (idx) {
      this.atStartOfDay.splice(idx, 1)
      this.isChangesMade = true
      if (this.atStartOfDay.length === 0) {
        this.isOn = false
      }
    },
    onSubmit () {
      let dbConfig = JSON.parse(JSON.stringify(this.config))

      if (!this.isOn) {
        delete dbConfig.at_start_of_day
      } else {
        dbConfig.at_start_of_day = this.atStartOfDay
      }
      this.$emit('onSubmit', dbConfig, this.newRulesArr())
      this.isChangesMade = false
    }
  },
  mounted () {
    if (this.propRules) {
      const idx = this.propRules.findIndex(item => item.id === this.subjectType)
      if (idx > -1) {
        this.selectedEmploymentTitle = JSON.parse(JSON.stringify(this.propRules[idx]['selected_employment_title']))
      }
    }
    if (this.config && this.config.at_start_of_day) {
      this.isOn = true
      this.atStartOfDay = JSON.parse(JSON.stringify(
        Array.isArray(this.config.at_start_of_day)
          ? this.config.at_start_of_day
          : [this.config.at_start_of_day]
      ))
    } else {
      this.atStartOfDay = [{time: '08:00', minutes: 10}]
    }
  }
}
</script>

<style scoped>

.salary-rules__rule-container {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  padding: 32px;
  padding: 2rem;
  border-radius: 4px;
  max-width: 600px;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-group .d-input {
  height: 34px;
  max-width: 150px;
  text-align: right;
}

.d-group {
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-groups {
  margin: 1rem 0;
}

.d-groups__group {
  border: 1px solid #e2e8f0;
  padding: 1rem;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
}

.d-groups__group > .d-group {
  margin: 1rem 0;
}

.btn--inline {
  display: inline-block;
}

.d-groups__group__delete-item {
  opacity: 0.7;
  margin-left: -0.5rem;
}

.d-groups__group__delete-item:hover {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// SalaryRule4.vue?112f9059